require('./index.module');
require('./templates/carousel.html');
require('./templates/post.html');
require('./templates/rubric.html');
require('./templates/project.html');
require('./controllers/view.controller');